import HTTP from "../../http";
import Jsona from "jsona";
import paramsHelper from "../../helpers/params";

const dataFormatter = new Jsona();

function buildOrderHasPreferencesBody(orderId, configurableFieldId, answer) {
  return {
    data: {
      type: "order_has_preferences",
      attributes: { answer: answer },
      relationships: {
        order: { data: { type: "orders", id: orderId } },
        configurable_field: {
          data: { type: "configurable_fields", id: configurableFieldId }
        }
      }
    }
  };
}

export default {
  async index(orderId) {
    try {
      const filters = [{ name: "order", value: orderId }];

      const params = paramsHelper.buildParams({ filters });

      const results = await HTTP.normal.get(`/order-has-preferences${params}`);

      return {
        data: dataFormatter.deserialize(results.data),
        meta: results.data.meta
      };
    } catch (_) {
      throw "Ocorreu um erro ao listar as preferências dos pedidos!";
    }
  },

  async show(id) {
    try {
      const orderHasPreferences = await HTTP.normal.get(
        `/order-has-preferences/${id}`
      );

      return dataFormatter.deserialize(orderHasPreferences.data);
    } catch (_) {
      throw "Ocorreu um erro ao buscar a preferência do pedido!";
    }
  },

  async getOrderPreference(orderId, configurableFieldId) {
    try {
      const filters = [{ name: "order_id", value: orderId }];

      if (configurableFieldId != null) {
        filters.push({
          name: "configurable_field_id",
          value: configurableFieldId
        });
      }

      const params = paramsHelper.buildParams({ filters });

      const results = await HTTP.normal.get(`/order-has-preferences${params}`);

      return dataFormatter.deserialize(results.data);
    } catch (_) {
      throw "Ocorreu um erro ao obter as preferências dos pedidos!";
    }
  },

  async create(orderId, configurableFieldId, answer) {
    try {
      const body = buildOrderHasPreferencesBody(
        orderId,
        configurableFieldId,
        answer
      );

      const order = await HTTP.normal.post("/order-has-preferences", body);
      return dataFormatter.deserialize(order.data);
    } catch (_) {
      throw "Ocorreu um erro ao criar a preferência do pedido!";
    }
  }
};



// WEBPACK FOOTER //
// ./src/api/modules/preferences/orderHasPreferences.js